<template>
  <div class="notarizaBox">
    <div class="notarizaSearch">
      <div class="serach-content">
        <span class="serach_title">申请时间：</span>
        <el-date-picker
          @change="searchChange"
          class="dataPickerCustom"
          v-model="searchData.signStartTimeBegin"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择时间"
          :picker-options="signDeadlineDateOption"
        ></el-date-picker>
        <span>&nbsp;-&nbsp;&nbsp;&nbsp;</span>
        <el-date-picker
          @change="searchChange"
          class="dataPickerCustom"
          value-format="yyyy-MM-dd"
          v-model="searchData.signStartTimeEnd"
          type="date"
          placeholder="选择时间"
          :picker-options="signDeadlineDateOption"
        ></el-date-picker>
        <span class="serach_title">公证状态：</span>
        <el-select
          v-model="searchData.notarizaStatus"
          placeholder="请选择公证状态"
        >
          <el-option
            :label="item.label"
            :value="item.value"
            v-for="(item, index) in options"
            :key="index"
          ></el-option>
        </el-select>
        <span class="serach_title">关键字：</span>
        <el-input
          class="search_input"
          v-model="notarizaName"
          placeholder="支持合同编码、合同名称、公证编码搜索"
        ></el-input>
        <span class="search" @click="searchFn">搜索</span>
      </div>
      <span class="search" @click="exportFn">导出查询结果</span>
    </div>
    <el-table border :data="tableData">
      <template slot="empty">
        <img class="data-pic" src="../../../../assets/images/H5/null.png" alt />
        <br />暂无数据
      </template>
      <el-table-column
        prop="contractCode"
        label="合同编号"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="contractName"
        label="合同名称"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="evidenceCode"
        label="公证编码"
        width="140"
      ></el-table-column>
      <!-- <el-table-column
        prop="notarizationName"
        label="公证名称"
        width="140"
      ></el-table-column> -->
      <el-table-column label="公证状态" width="120">
        <template slot-scope="scope">
          <span class="waiting" v-if="scope.row.status == 1">等待提交</span>
          <span class="failed" v-if="scope.row.status == 0">审核拒绝</span>
          <span class="failed" v-if="scope.row.status == 6">等待签署</span>
          <span class="waiting" v-if="scope.row.status == 3">等待付费</span>
          <span class="waiting" v-if="scope.row.status == 4">等待制证</span>
          <span class="finished" v-if="scope.row.status == 5">已公证</span>
          <span class="waiting" v-if="scope.row.status == 2">等待审核</span>
          <span class="failed" v-if="scope.row.status == 8">申请失败</span>
          <span class="waiting" v-if="scope.row.status == 7">他人办理</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userRegisterName"
        label="申请人"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="申请时间"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="notaryRemark"
        label="备注"
        width="140"
      ></el-table-column>
      <!-- <el-table-column  label="类型" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.notarizationType==1">一般公证</span>
          <span v-if="scope.row.notarizationType==2">赋强公证</span>
        </template>
      </el-table-column> -->
      <el-table-column label="公证进度" width="100">
        <template slot-scope="scope">
          <span @click="detailFn(scope.row.id)">查看</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <span
            class="operation_item"
            type="text"
            size="small"
            @click="goNotarialDetails(scope.row.id)"
            >公证详情</span
          >
          <span
            class="operation_item"
            type="text"
            size="small"
            @click="goDataDetail(scope.row)"
            >证据详情</span
          >
          <!-- v-if="scope.row.status>=3 && scope.row.status<4"
           v-if="scope.row.status>=3 && scope.row.status<4"
            v-if="scope.row.status<=3 && scope.row.status!=0" -->
          <!-- <el-button type="text" size="small" v-if="scope.row.status!=3" style="color: rgb(200, 200, 200);">去支付</el-button> -->
          <span
            class="operation_item"
            type="text"
            size="small"
            v-if="
              scope.row.status == 2 &&
              currentInfo &&
              currentInfo.userId == scope.row.userId
            "
            @click="cancelNotarizationFn(scope.row.id)"
            >取消公证</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="showPagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <Dialog
      :visible="successBox"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
      class="hintMessageBox"
    >
      <div slot="dialog">
        <div class="hintMessCon">
          <p>是否取消公证</p>
          <p>
            <span @click="cancelFn">取消</span>
            <span @click="trueFn">确定</span>
          </p>
        </div>
      </div>
    </Dialog>

    <Dialog
      :visible="executeVisible"
      dialogTitle="申请执行"
      v-on:closeDialog="
        executeVisible = false;
        resetForm();
      "
      :width="'500px'"
      class="execute-dialog"
    >
      <div slot="dialog">
        <div class="hintMessCon">
          <el-form
            class="dialog-main"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <el-form-item label="公证编号:">
              <el-input
                :value="selectRowData && selectRowData.evidenceCode"
                placeholder="请输入公证编号"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="执行法院:" prop="selectCourId">
              <el-select
                v-model="ruleForm.selectCourId"
                placeholder="请选择执行法院"
                :disabled="selectRowData && selectRowData.courtId"
              >
                <el-option
                  :label="item.courtShortName"
                  :value="item.id"
                  v-for="item in courList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="authHandlerBox" style="margin: 0 auto; margin-top: 40px">
            <template v-if="selectRowData && !selectRowData.courtId">
              <div
                class="button-primary-plain"
                @click="
                  executeVisible = false;
                  resetForm();
                "
              >
                取消
              </div>
              <div class="button-primary" @click="applyExecute()">确定</div>
            </template>
            <template v-else>
              <div
                class="button-primary"
                @click="
                  executeVisible = false;
                  resetForm();
                "
              >
                确定
              </div>
            </template>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import storageUtil from "@lib/storageUtil.js";
import Util from "@lib/util.js";
import Dialog from "@common/Dialog.vue";
import { mapState } from "vuex";
import download from "@lib/download.js";
export default {
  data() {
    return {
      type: 1,
      successBox: false,
      showPagination: false,
      currentPage: 1, //默认第一页
      total: 80, //总条数
      pageSizes: [10, 20, 50, 100, 200], //每页展示多少条
      pageSize: 10, //默认第一页展示10条
      tableData: [],
      notarizaName: "", //公证名称
      notarizaCode: "", //公正码
      notarizaData: "", //公证处
      id: "",
      searchData: {
        signStartTimeBegin: "",
        signStartTimeEnd: "",
        contractName: "",
        dataRange: "",
        notarizaStatus: "",
        organization: "",
      },
      signDeadlineDateOption: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "等待提交",
        },
        {
          value: "2",
          label: "等待审核",
        },
        {
          value: "0",
          label: "审核拒绝",
        },
        {
          value: "5",
          label: "已公证",
        },
        {
          value: "6",
          label: "等待签署"
        },
        {
          value: "7",
          label: "他人办理"
        },
      ],
      status: "", //当前状态,
      executeVisible: false,
      selectRowData: null,
      courList: [],
      ruleForm: {
        selectCourId: null,
      },
      rules: {
        selectCourId: [
          { required: true, message: "请选择执行法院", trigger: "change" },
        ],
      },
      notaryBusinessId: "", // 贷款强制公证：3，调解强执公证：8
    };
  },
  methods: {
    //跳转公证详情
    goNotarialDetails(id) {
      this.$router.push({
        path: "/personal/serviceHome/writeProcedure/fqNotarialDetail",
        query: {
          id: id,
          flag: 4,
          notaryBusinessId: this.notaryBusinessId,
        },
      });
    },
    //跳转证据详情
    goDataDetail(item) {
      // this.$router.push({
      //   path: "/personal/serviceHome/writeProcedure/fqDataDetail",
      //   query: {
      //     notarizationID: item.sourceId,
      //     id: item.id,
      //     source: item.source,
      //     name: item.notarizationName,
      //     flag: 4,
      //     notaryBusinessId: this.notaryBusinessId,
      //   },
      // });
      // BaseApi.createRpcToken("/notaryApply/getEvidenceList", {
      //   evidenceName: item.notarizationName,
      //   pageNumber: 1,
      //   pageSize: 10,
      //   notaryApplyId: item.id
      // }, "GET").then(res => {
      //   let fileId = res.datas.list[0].contractFileId
      //   BaseApi.createRpcToken("/file/downloadContractFileZip", { fileId })
      //     .then(data => {
      //       if (data.datas.zipUrl) {
      //         try {
      //           var elemIF = document.createElement("iframe");
      //           elemIF.src = data.datas.zipUrl;
      //           elemIF.style.display = "none";
      //           elemIF.setAttribute('id', 'startDown');
      //           if (document.getElementById('startDown')) {
      //             document.body.removeChild(document.getElementById('startDown'));
      //           }
      //           document.body.appendChild(elemIF);
      //         } catch (e) { }
      //         // window.open(data.datas.zipUrl);
      //       } else {
      //         this.$message.error("下载失败");
      //       }
      //     })
      //     .catch(function (e) {
      //       errorLog(e);
      //     });
      // })
      if (!(item.status == 5)) {
        this.$message({
          message: "暂未生成公证书",
          type: "warning",
        });
        return;
      }
      BaseApi.createRpcToken(
        "/notaryApply/downloadDataRight",
        {
          rightId: item.certificateDataRightId,
        },
        "GET"
      ).then((res) => {
        if (res.code == 200) {
          this.loading = false;

          var elemIF = document.createElement("iframe");
          elemIF.src = res.datas.path;
          elemIF.style.display = "none";
          elemIF.setAttribute("id", "startDown");
          if (document.getElementById("startDown")) {
            document.body.removeChild(document.getElementById("startDown"));
          }
          document.body.appendChild(elemIF);
        }
        //  else if (res.code == 20001) {
        //   this.loading = true;
        //   if (item.queryCount < 4) {
        //     setTimeout(() => {
        //       item.queryCount++;
        //       this.downLoadFn(item);
        //     }, 2000);
        //   }
           else {
            // item.queryCount = 0;
            this.$message.error(res.message);
          }
        // }
      });
    },
    ormatDat(secs) {
      //123456789 --> 年-月-日 时：分：秒
      var t = new Date(secs);
      var year = t.getFullYear();
      var month = t.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var date = t.getDate();
      if (date < 10) {
        date = "0" + date;
      }
      var hour = t.getHours();
      if (hour < 10) {
        hour = "0" + hour;
      }
      var minute = t.getMinutes();
      if (minute < 10) {
        minute = "0" + minute;
      }
      var second = t.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      return (
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
    searchChange() {
      if (
        this.searchData.signStartTimeBegin &&
        this.searchData.signStartTimeEnd
      ) {
        // console.log(this.searchData.signStartTimeBegin,this.searchData.signStartTimeEnd,Util);
        if (
          !Util.compareTime(
            this.searchData.signStartTimeBegin,
            this.searchData.signStartTimeEnd
          )
        ) {
          this.$message.error("开始时间不能大于结束时间");
          return;
        }
      }
      !this.searchData.signStartTimeBegin &&
        (this.searchData.signStartTimeBegin = "");
      !this.searchData.signStartTimeEnd &&
        (this.searchData.signStartTimeEnd = "");
      if (this.listFlag == storageUtil.getSession("signHomeCurrentListFlag")) {
        let temp = storageUtil.getSession(this.listFlag);
        if (temp) {
          temp = Object.assign(temp, this.searchData);
        }
        storageUtil.setSession(this.listFlag, this.searchData);
        this.$emit("searchChange", this.searchData);
      }
    },
    evidenceFn() {
      this.$router.push({
        path: "serviceHome/evidence",
      });
    },
    detailFn(id) {
      var params = {
        notaryApplyId: id,
      };
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/notaryApply/getNotarizationInfo", params, "GET")
        .then(
          (data) => {
            sessionStorage.setItem("procedure", JSON.stringify(data.datas));
            this.$store.commit("showLoading", false);
            this.$router.push({
              path: "/personal/serviceHome/writeProcedure",
              query: {
                notaryApplyId: id,
                fromType: 4,
                notaryBusinessId: this.notaryBusinessId,
              },
            });
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    closeDialog(data) {
      this.successBox = data;
    },
    cancelFn() {
      this.successBox = false;
    },
    goPay(num) {
      var params = {
        notaryServiceId: num,
      };
      BaseApi.createRpcToken("/Judiciary/getNotarizationInfo", params, "GET")
        .then(
          (data) => {
            sessionStorage.setItem("procedure", JSON.stringify(data.datas));
            this.$router.push({
              path: "serviceHome/evidence/procedure",
              query: {
                id: num,
              },
            });
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    cancelNotarizationFn(id) {
      this.successBox = true;
      this.id = id;
    },
    trueFn() {
      var params = {
        notaryApplyId: this.id,
      };
      BaseApi.createRpcToken(
        "/notaryApply/cancelNotarization",
        params,
        "post"
      ).then((data) => {
        this.successBox = false;
        this.init();
      });
    },
    init() {
      var params = {
        pageNumber: this.currentPage,
        notaryBusinessId: this.notaryBusinessId,
        notarizationType: 4,
        evidenceCode: this.notarizaName.trim(),
        // notarizationCode:this.notarizaName,
        // userRegisterName:this.notarizaName,
        applyStartTime: this.searchData.signStartTimeBegin
          ? this.searchData.signStartTimeBegin
          : "",
        applyEndTime: this.searchData.signStartTimeEnd
          ? this.searchData.signStartTimeEnd
          : "",
        status: this.searchData.notarizaStatus,
        // userRegisterName:this.notarizaName,
        // notarizationCode:this.notarizaName,
        pageSize: this.pageSize,
      };
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/notaryApply/notaryList", params, "GET")
        .then(
          (data) => {
            this.$store.commit("showLoading", false);
            let list = data.datas.list.list;
            if (data.datas != null && list.length) {
              this.tableData = list;
              for (var i = 0; i < list.length; i++) {
                list[i].createTime = this.ormatDat(list[i].createTime);
              }
              this.total = data.datas.list.totalRow;
              console.log(data.datas.list.totalRow);
              if (data.datas.list.totalRow > 10) {
                this.showPagination = true;
              } else {
                this.showPagination = false;
              }
            } else {
              this.showPagination = false;
              this.tableData = list;
            }
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    searchFn() {
      this.init();
    },
    // 导出
    exportFn() {
      var params = {
        pageNumber: 1,
        pageSize: 500,
        notaryBusinessId: this.notaryBusinessId,
        notarizationType: 4,
        evidenceCode: this.notarizaName.trim(),
        applyStartTime: this.searchData.signStartTimeBegin
          ? this.searchData.signStartTimeBegin
          : "",
        applyEndTime: this.searchData.signStartTimeEnd
          ? this.searchData.signStartTimeEnd
          : "",
        status: this.searchData.notarizaStatus,
      };
      BaseApi.createRpcToken(
        "/notaryApply/notaryServicesExport",
        params,
        "POST",
        false,
        false,
        true,
        "blob"
      )
        .then(
          (res) => {
            download(
              new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }),
              "强执公证",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            );
          },
          () => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.init();
    },
    getCourtList() {
      BaseApi.createRpcToken("/court/getCourtList", {}, "GET")
        .then(
          (data) => {
            const { datas } = data;
            this.courList = datas.courtList;
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    applyExecute() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          BaseApi.createRpcToken(
            "/court/applyExecute",
            {
              applyId: this.selectRowData.id,
              courtId: this.ruleForm.selectCourId,
            },
            "GET"
          )
            .then(
              (data) => {
                const { code } = data;
                if (code == 200) {
                  this.resetForm();
                  this.executeVisible = false;
                  this.init();
                }
              },
              (data) => {}
            )
            .catch(function (e) {
              errorLog(e);
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
  created() {
    this.notaryBusinessId = this.$route.name == "serviceLoan" ? "3" : "8";
    this.init();
    this.type = JSON.parse(sessionStorage.getItem("userInfo")).realNameType;
    this.getCourtList();
  },
  components: {
    Dialog,
  },
  computed: {
    ...mapState(["currentInfo"]),
  },
  watch: {
    currentInfo(data) {
      this.init();
    },
  },
};
</script>
<style lang="scss">
@import "@assets/scss/base.scss";

.el-table__body,
.el-table__footer,
.el-table__header {
  table-layout: auto !important;
  border-collapse: separate;
}

.notarizaBox {
  height: 100%;
  width: 100%;

  .el-table__cell {
    padding: 5px 0px !important;
  }

  .notarizaSearch {
    width: 100%;
    margin-bottom: 20px;
    overflow: hidden;
    display: flex;
    align-items: center;
    // justify-content: space-between;

    .serach-content {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .el-input {
      height: 30px;
      margin-right: 10px;

      .el-input__inner {
        height: 30px;
        line-height: 28px;
        border-radius: 0;
      }

      .el-input__icon {
        line-height: 28px;
      }
    }

    .search_input {
      width: 250px;
    }

    .serach_title {
      font-size: 12px;
      font-weight: 400;
      color: #4a4a4a;
    }

    // .el-input:nth-child(1) {
    //   width: 180px;
    // }
    // .el-input:nth-child(2) {
    //   width: 193px;
    // }
    .el-select {
      float: left;

      .el-input {
        width: 151px;
      }
    }

    .organization {
      .el-input {
        width: 130px;
      }
    }

    .el-input__inner::placeholder {
      font-size: 12px;
      color: #b9b9b9;
    }

    .search {
      width: auto;
      padding: 0 8px;
      box-sizing: border-box;
      min-width: 74px;
      height: 30px;
      background: #d81212;
      border-radius: 2px;
      font-size: 13px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 30px;
      clear: left;
      // background: url("../../../../assets/images/warning/search_icon_nor.png")
      //   no-repeat;
      cursor: pointer;
      // img {
      //   width: 100%;
      //   height: 100%;
      // }
    }

    .search:hover {
      // background: url("../../../../assets/images/warning/search_icon_pre.png");
    }
  }

  table {
    width: 100% !important;

    th,
    td {
      vertical-align: middle;
      height: 30px;
      padding: 0;
      text-align: center;

      .cell {
        padding: 0;
        text-align: center;
        color: #242c32 !important;
        font-size: 12px;
        height: 100%;
      }
    }

    td {
      .cell {
        color: #242c32 !important;
      }
    }

    // th:nth-child(1),
    // td:nth-child(1) {
    //   width: 18%;
    // }
    // th:nth-child(2),
    // td:nth-child(2) {
    //   width: 13.7%;
    // }
    // th:nth-child(3),
    // td:nth-child(3) {
    //   width: 11.3%;
    // }
    // th:nth-child(4),
    // td:nth-child(4) {
    //   width: 7%;
    // }
    // th:nth-child(5),
    // td:nth-child(5) {
    //   width: 8%;
    // }
    // th:nth-child(6),
    // td:nth-child(6) {
    //   width: 11.7%;
    // }
    // th:nth-child(7),
    // td:nth-child(7) {
    //   width: 6.5%;
    // }
    // th:nth-child(8),
    // td:nth-child(8) {
    //   width: 21.8%;
    // }

    td:nth-child(7) {
      // span:hover {
      //   cursor: pointer;
      //   color: #e88078;
      // }
      span {
        color: #0091ff;
        margin-right: 10px;
        cursor: pointer;
      }

      span:last-child {
        margin: 0;
      }
    }

    td:nth-child(8) {
      span {
        color: #242c32;
        margin-right: 10px;
        cursor: pointer;
      }

      span:hover {
        color: #d81212;
      }
    }

    thead {
      tr {
        th {
          background-color: #f9f9f9;
        }
      }
    }

    .operation_item {
      margin: 0 5px;
      cursor: pointer;
    }
  }

  .hintMessageBox {
    .hintMessCon {
      display: flex;
      flex-direction: column;
      height: 200px;
    }

    p:nth-child(1) {
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    p:nth-child(2) {
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      height: 50px;

      span {
        display: block;
        width: 100px;
        height: 30px;
        border: 1px solid #db4437;
        line-height: 30px;
        padding: 0;
        border-radius: 0;
        background-color: #fff;
        font-size: 12px;
        color: #646464;
        text-align: center;
      }

      span:last-child {
        color: #db4437;
        margin-left: 100px;
      }

      span:hover {
        color: #fff;
        border-color: #db4437;
        background-color: #db4437;
      }
    }
  }

  .dataPickerCustom {
    width: 135px;
    height: 30px;

    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }

    .el-input--suffix .el-input__inner {
      padding-right: 20px;
    }

    .input__inner {
      padding-right: 0;
    }

    .el-input__icon {
      line-height: 30px;
    }
  }
}

.waiting {
  color: #f6a11b;
}

.failed {
  color: $reminder-text;
}

.finished {
  color: #38da12;
}

.execute-dialog {
  .hintMessCon {
    padding: 40px 0;

    .dialog-main {
      width: 310px;
      margin: 0 auto;

      .el-form-item__label {
        width: 90px;
        text-align: right;
      }

      .el-form-item__error {
        text-align: right;
        right: 0;
      }

      .el-input {
        width: 220px;
        height: 30px;

        .el-input__inner {
          height: 30px;
          line-height: 30px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 20px;
        }

        .input__inner {
          padding-right: 0;
        }

        .el-input__icon {
          line-height: 30px;
        }
      }
    }

    .authHandlerBox {
      width: 310px;
      margin: auto;
      justify-content: center;

      div:nth-child(2) {
        margin-left: 20px;
      }
    }
  }
}

.button-primary-plain {
  display: block;
  width: 100px;
  height: 30px;
  border: 1px solid #db4437;
  line-height: 30px;
  padding: 0;
  border-radius: 0;
  background-color: #fff;
  font-size: 12px;
  color: #db4437;
  text-align: center;

  &:hover {
    background-color: #db4437;
    color: #fff;
  }
}

.button-primary {
  display: block;
  width: 100px;
  height: 30px;
  border: 1px solid #db4437;
  line-height: 30px;
  padding: 0;
  border-radius: 0;
  background-color: #db4437;
  font-size: 12px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
</style>
